<button class="cx_button__container" 
    [ngClass]="{'cx_button--primary': isPrimaryButton,'not-allowed': isDisabled}" 
    [disabled]=" isDisabled ? true : false">{{messageText}}</button>